import React from 'react';
import './styles/Filters.css';

const ToggleSwitch = ({ 
  checked, 
  onChange, 
  label = "Only show disabled access",
  id = "disabledAccessToggle" 
}) => {
  return (
    <div className="toggle-row">
      <span className="disabled-access-label" id={`${id}-label`}>{label}</span>
      <div className="toggle-switch">
        <input 
          type="checkbox" 
          id={id} 
          checked={checked} 
          onChange={onChange} 
          className="disabled-access-checkbox" 
          aria-checked={checked}
          aria-labelledby={`${id}-label`}
          role="switch"
        />
        <label 
          htmlFor={id} 
          className="disabled-access-label-switch"
          tabIndex={0}
          role="switch"
          aria-checked={checked}
          aria-labelledby={`${id}-label`}
          onKeyDown={e => {
            if (e.key === ' ' || e.key === 'Enter') {
              e.preventDefault();
              onChange({ target: { checked: !checked } });
            }
          }}
        ></label>
      </div>
    </div>
  );
};

export default ToggleSwitch; 